<template>
  <section>
    <div>
      Data sourced from Nielsen Super Data, Forbes and Social Blade. Views and ad revenue accurate as of July 2021.
For any questions on this research, please get in touch.
    </div>
  </section>
</template>

<style lang="scss" scoped>
section{
  margin:40px 0px 40px 0px;
  padding:20px;
  font-style:italic;
}
</style>